import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const SearchRecoverTeamsInputSchema = z.object({
  query: z.string().describe("Search query for team name"),
  limit: z
    .number()
    .optional()
    .default(20)
    .describe("Maximum results to return"),
});

export const SearchRecoverTeamsOutputSchema = z.object({
  teams: z.array(z.object({ _id: zExt.objectId(), name: z.string() })),
});

export type SearchRecoverTeamsInput = z.infer<
  typeof SearchRecoverTeamsInputSchema
>;
export type SearchRecoverTeamsOutput = z.infer<
  typeof SearchRecoverTeamsOutputSchema
>;

export const searchRecoverTeams = {
  name: "searchRecoverTeams" as const,
  input: SearchRecoverTeamsInputSchema,
  output: SearchRecoverTeamsOutputSchema,
};
